import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArtikelGruppen } from '../../store/models/artikelgruppen';
import { NavService } from '../nav/shared/nav.service';

@Component({
    selector: 'app-webshop-view',
    templateUrl: './webshop-view.component.html',
    styleUrls: ['./webshop-view.component.scss']
})
export class WebshopViewComponent implements OnInit, AfterViewInit {

    // sidenav based on 
    // https://coderedirect.com/questions/170834/open-close-sidenav-from-another-component

    @ViewChild('sidenav') 
    public sidenav: MatSidenav;

    // TopLevelOption from Route
    // topLevelOption: string;

    // queryparams from Route
    search: Observable<string>;
    category: Observable<string>;
    minPreis: Observable<number>;
    maxPreis: Observable<number>;
    groessen: Observable<number[]>;
    farben: Observable<number[]>;
    merkmale: Observable<number[]>;
    nurAufLager: Observable<boolean>;
    reload: boolean;
    showWarenkorb: boolean;
    showAdvertise: boolean;

    numberWarenkorbItems: number;

    // Utils
    isLoading: boolean = true;
    isReload: boolean = false;
    
    constructor(
        private activatedRoute: ActivatedRoute,
        private navService: NavService,
        private oAuthService:OAuthService
    ) {

        // environment.oAuthConfig.redirectUri+='/webshop';
        // oAuthService.configure(environment.oAuthConfig);
        // oAuthService.loadDiscoveryDocumentAndTryLogin();
    }

    ngAfterViewInit(): void {
        this.navService.setSidenav(this.sidenav);
    }

    ngOnInit(): void {
        //document.title = 'Hello World!';

        //alert('ngOnInit: webshop-view.components.ts');

        this.showAdvertise = true;

        //console.log("params: "+this.activatedRoute.queryParams);

        this.activatedRoute.queryParams.subscribe(par => {

            this.search = par['search'];
            this.category = par['category'];

            if (par['minPreis']) {
                this.minPreis = par['minPreis'];
            }

            if (par['maxPreis']) {
                this.maxPreis = par['maxPreis'];
            }
            this.groessen = par['groessen'];
            this.farben = par['farben'];
            this.merkmale = par['merkmale'];

            if (par['nurAufLager']) {
                this.nurAufLager = par['nurAufLager'];
            }

            this.showWarenkorb = par['showWarenkorb'];
            if (par['showWarenkorb'] == "true") {
                this.showWarenkorb = par['showWarenkorb']=="true";
            } else {
                this.showWarenkorb = false;
            }
        
            //Advertise?
            //console.log("param showAdvertise: "+par['showAdvertise']);
            //alert("param showAdvertise: "+par['showAdvertise']);

            //this.showAdvertise = par['showAdvertise'];
            //if (par['showAdvertise'] == "false" || par['showAdvertise'] == undefined) { 
            if (par['showAdvertise'] == "false") { 
                this.showAdvertise = false;
            } else if (par['showAdvertise'] == undefined && this.showAdvertise == false) {
                this.showAdvertise = false;
            } else {
                //alert("showAdvertise set true");
                this.showAdvertise = true;
            }

            this.isLoading = false;

        });
    }

    getNumberWarenkorbItems(event) {

        console.log("getnwarkorbitems => ", event);

        this.numberWarenkorbItems = event;
    }
}
